<template>
  <div id="ly_hotel_edit">
    <div class="page-header">
      <el-page-header @back="$router.back()" :content="isEdit ? '编辑酒店' : '创建酒店'" />
    </div>
    <el-form :model="form" :rules="rules" ref="hotelForm" label-width="120px" class="edit-form">
      <el-card class="form-card" header="基本信息">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="酒店名称" prop="name">
              <el-input v-model="form.name" placeholder="请输入酒店名称" maxlength="100" show-word-limit />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话" prop="contactPhone">
              <el-input v-model="form.contactPhone" placeholder="请输入联系电话" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="酒店星级" prop="starLevel">
              <el-select v-model="form.starLevel" placeholder="请选择星级" style="width:100%">
                <el-option label="经济型" :value="1" />
                <el-option label="舒适型" :value="2" />
                <el-option label="高档型" :value="3" />
                <el-option label="豪华型" :value="4" />
                <el-option label="五星级" :value="5" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="适用城市" prop="cityCode">
              <el-cascader v-model="cityArr" :options="cityCodeJson" :props="cityProps"
                @change="onCityChange" style="width:100%" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="酒店地址" prop="address">
              <el-input v-model="form.address" placeholder="请输入详细地址" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="入住时间" prop="checkInTime">
              <el-time-select v-model="form.checkInTime" :picker-options="{ start: '00:00', step: '00:30', end: '23:30' }"
                placeholder="入住时间" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="退房时间" prop="checkOutTime">
              <el-time-select v-model="form.checkOutTime" :picker-options="{ start: '00:00', step: '00:30', end: '23:30' }"
                placeholder="退房时间" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="酒店设施" prop="facilities">
              <el-input v-model="form.facilities" placeholder="设施标签，多个用逗号分隔，如：WiFi,停车场,游泳池" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>

      <el-card class="form-card" header="酒店图片">
        <el-form-item label="主图" prop="hotelImg">
          <div class="img-list">
            <div v-for="(img, idx) in imgList" :key="idx" class="img-item">
              <el-image :src="img" fit="cover" style="width:100px;height:80px;border-radius:4px" />
              <el-button type="text" class="img-del" @click="removeImg(idx)">删除</el-button>
            </div>
            <el-upload class="img-upload" action="/api/v1/upload/img" :show-file-list="false"
              :on-success="onImgUpload" accept="image/*">
              <div class="upload-btn"><i class="el-icon-plus" /></div>
            </el-upload>
          </div>
        </el-form-item>
      </el-card>

      <el-card class="form-card" header="酒店介绍">
        <el-form-item label="酒店描述" prop="hotelDescribe">
          <el-input v-model="form.hotelDescribe" type="textarea" :rows="6" placeholder="请输入酒店描述（支持富文本）" />
        </el-form-item>
      </el-card>

      <div class="form-footer">
        <el-button @click="$router.back()">取消</el-button>
        <el-button type="primary" :loading="loading" @click="submitForm">保存</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import { cityCodeJson } from "@/assets/js/city";
export default {
  name: "ly_hotel_edit",
  data() {
    return {
      cityCodeJson,
      cityArr: [],
      cityProps: { label: "name", value: "citycode", children: "districts" },
      loading: false,
      imgList: [],
      form: {
        id: null,
        name: "",
        contactPhone: "",
        starLevel: null,
        province: "",
        city: "",
        area: "",
        cityCode: "",
        address: "",
        longitude: null,
        latitude: null,
        checkInTime: "14:00",
        checkOutTime: "12:00",
        facilities: "",
        hotelImg: "",
        hotelDescribe: "",
        status: 2,
      },
      rules: {
        name: [{ required: true, message: "请输入酒店名称", trigger: "blur" }],
        starLevel: [{ required: true, message: "请选择星级", trigger: "change" }],
        address: [{ required: true, message: "请输入酒店地址", trigger: "blur" }],
      },
    };
  },
  computed: {
    isEdit() {
      return !!this.$route.query.id;
    },
  },
  created() {
    if (this.isEdit) {
      this.loadHotel();
    }
  },
  methods: {
    async loadHotel() {
      let { code, data } = await this.$axios.get(`/api/v1/manage/travelHotel/${this.$route.query.id}`);
      if (code === 1 && data) {
        Object.keys(this.form).forEach(k => { if (data[k] !== undefined) this.form[k] = data[k]; });
        if (data.hotelImg) {
          this.imgList = data.hotelImg.split(",").filter(Boolean);
        }
        if (data.cityCode) {
          this.cityArr = [data.province, data.city, data.cityCode].filter(Boolean);
        }
      }
    },
    onCityChange(val) {
      if (val && val.length > 0) {
        this.form.cityCode = val[val.length - 1];
        this.form.city = val[val.length > 1 ? val.length - 2 : 0];
        this.form.province = val[0] || "";
      }
    },
    onImgUpload(res) {
      if (res.code === 1 && res.data) {
        this.imgList.push(res.data);
        this.form.hotelImg = this.imgList.join(",");
      }
    },
    removeImg(idx) {
      this.imgList.splice(idx, 1);
      this.form.hotelImg = this.imgList.join(",");
    },
    submitForm() {
      this.$refs.hotelForm.validate(async (valid) => {
        if (!valid) return;
        this.loading = true;
        try {
          let url = "/api/v1/manage/travelHotel";
          let { code } = this.isEdit
            ? await this.$axios.put(url, this.form)
            : await this.$axios.post(url, this.form);
          if (code === 1) {
            this.$message.success(this.isEdit ? "修改成功" : "创建成功");
            this.$router.push({ path: "/travelHotel" });
          }
        } finally {
          this.loading = false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
#ly_hotel_edit {
  padding: 16px;
  .page-header { margin-bottom: 16px; }
  .form-card { margin-bottom: 16px; }
  .edit-form { max-width: 900px; }
  .form-footer { text-align: center; padding: 20px 0; }
  .img-list {
    display: flex; flex-wrap: wrap; gap: 10px;
    .img-item { position: relative; display: inline-block; }
    .img-del { position: absolute; bottom: 0; left: 0; right: 0; text-align: center; background: rgba(0,0,0,.4); color: #fff; }
    .img-upload { display: inline-block; }
    .upload-btn {
      width: 100px; height: 80px; border: 1px dashed #d9d9d9; border-radius: 4px;
      display: flex; align-items: center; justify-content: center; cursor: pointer; font-size: 24px; color: #999;
      &:hover { border-color: #409EFF; color: #409EFF; }
    }
  }
}
</style>
